export function logoutUserStorage() {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
}
